/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../Utilities/i18n/i18n.js';
import { noopFn } from '../../../Utilities/propHelpers/defaultProps.js';
import SidePanel from '../SidePanel/SidePanel.js';
import SidePanelContainer from '../SidePanel/SidePanelContainer.js';

var _excluded = ["id", "open", "onClose", "panelTitle", "children", "isHelp"];

/**
 * Adds a right margin to the body to push content.
 */
var addMargin = function addMargin() {
  return document.body.classList.add('cpc--push-panel-open');
};

/**
 * Removes the right margin from the body.
 */
var removeMargin = function removeMargin() {
  return document.body.classList.remove('cpc--push-panel-open');
};
var PushPanel = function PushPanel(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'help' : _ref$id,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noopFn : _ref$onClose,
    panelTitle = _ref.panelTitle,
    children = _ref.children,
    isHelp = _ref.isHelp,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (open) {
      addMargin();
    } else {
      removeMargin();
    }
    return removeMargin;
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cpc--push-panel ".concat(isHelp ? 'cpc--push-panel__help' : '')
  }, /*#__PURE__*/React.createElement(SidePanelContainer, _extends({
    id: "".concat(id, "-side-panel-container"),
    isOpen: open,
    panelSize: "small",
    onCloseClick: onClose,
    hideBottomNav: true,
    hasOverlay: false
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, others), /*#__PURE__*/React.createElement(SidePanel, {
    id: "".concat(id, "-side-panel"),
    title: panelTitle,
    closePanelText: t('Close Push Panel')
  }, children)));
};
PushPanel.propTypes = {
  /**
   * Provide an `id` to uniquely identify the PushPanel component
   */
  id: PropTypes.string,
  /**
   * Determines if the panel is displayed or not.
   */
  open: PropTypes.bool,
  /**
   * Custom function that will be called when the "close" button (x) is clicked.
   */
  onClose: PropTypes.func,
  /**
   * The title of the push panel.
   */
  panelTitle: PropTypes.node,
  /**
   * The content of the panel.
   */
  children: PropTypes.node.isRequired,
  /**
   * Whether or not the narrow padding should be used for the side panel content.
   */
  isHelp: PropTypes.bool
};
var PushPanel$1 = PushPanel;

export { PushPanel$1 as default };
